<template>
  <div class="tost">
    <Modal
      v-model="modal1"
      class="tagsModal newModal"
      :title="item.messageTitle"
      :closable="false"
      :mask-closable="false"
    >
      {{ item.messageContent }}
      <div slot="footer">
        <Button v-if="articles.length == 0" @click="del(item)" type="primary"
          >关闭</Button
        >
        <div
          v-else
          @click="del(item)"
          class="suce pot u-flex u-row-right"
          type="text"
        >
          <div>下一条</div>
          <Icon
            style="position: relative; top: 1px"
            color="#0c479d"
            type="ios-arrow-forward"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      articles: (state) => {
        return state.articles;
      },
    }),
  },
  watch: {
    $route: {
      immediate: true,
      
      handler(np, op) {
      
       let newvlaue=this.articles
   
          if (newvlaue.length > 0 && this.modal1 == false) {
        this.getItem();
      }
      },
    },
    articles(newvlaue) {
    
    },
  },
  data() {
    return {
      modal1: false,
      item: {
        messageTitle: "",
        messageContent: "",
      },
    };
  },
  mounted() {},
  methods: {
    getItem() {
      if (this.articles.length > 0) {
        if (!this.modal1) {
          this.modal1 = true;
        }
        let articles = this.articles;
        this.item = articles.shift();
        this.$store.dispatch("clearcleaction", { id: this.item.id });
      } else {
        this.modal1 = false;
      }
    },
    del(row) {
      let item = this.articles.find((e) => e.id == row.id);
      if (item) {
        this.articles.shift();
      }
      this.$nextTick(() => {
        this.$nextTick(() => {
          this.getItem();
        });
      });
    },
  },
};
</script>
<style scoped>
.tost {
  position: relative;
  top: 2px;
  z-index: 1000;
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  width: 60vw;
}
.suce {
  color: #0c479d;
}
</style>